import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { CreditFacilityReceivablesDashboardRoute } from 'borrower/routes/receivables/CreditFacilityReceivablesDashboardRoute';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { AthenaSchemaProvider } from 'packages/organization/hooks/AthenaSchemaContext';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Exports
export const CreditFacilityReceivablesDashboardRouter = () => {
  const { user } = useUserAuthOrThrow();
  const { creditFacilityId } = useCreditFacilityContext();
  return (
    <AthenaSchemaProvider organizationId={user.organizationId}>
      {/* Paths relative to "/credit-facility-receivables/*" */}
      <Routes>
        <Route
          path="/:creditFacilityId"
          element={<CreditFacilityReceivablesDashboardRoute />}
        />
        <Route
          path="/*"
          element={
            <Navigate to={`/credit-facility-receivables/${creditFacilityId}`} />
          }
        />
      </Routes>
    </AthenaSchemaProvider>
  );
};
